import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import SinExpandir from "../../../layout/HelperDataTable/SinExpandir";
import ListBadge from "../../../layout/ListBadge";
import { FilterYear, useSimpleTableConfig } from "../../../constants";
import { dataInfContable } from "../../../data/dataTransparencia";
import { dataCuentaPublicaNew } from "../../../data/2024/dataCuentaPublica";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { dataInfo2026 } from "../../../data/dataTransparencia";

const baseUrl = "https://itetlax.org.mx/assets/pdf/transparencia/infContable";

const PdfLink = ({ url }) => {
  const fullUrl = `${baseUrl}/${url}`;
  return (
    <a href={fullUrl} target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon
        icon={faFilePdf}
        style={{ color: "#d32f2f", fontSize: "1.5rem" }}
      />
    </a>
  );
};

PdfLink.propTypes = {
  url: PropTypes.string.isRequired,
};

const Accordion = ({ idAccordion, clasName, children }) => {
  return (
    <div className={`accordion ${clasName}`} id={idAccordion}>
      {children}
    </div>
  );
};

const AccordionItem = ({
  flushID,
  titleItem,
  contentItem,
  isOpen,
  toggleItem,
}) => {
  return (
    <div className="accordion-item" style={{ fontSize: "18px" }}>
      <h2 className="accordion-header" id={`heading-${flushID}`}>
        <button
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
          type="button"
          onClick={toggleItem}
          aria-expanded={isOpen}
          aria-controls={`collapse-${flushID}`}
          style={{ fontSize: "18px" }}
        >
          {titleItem}
        </button>
      </h2>
      <div
        id={`collapse-${flushID}`}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        aria-labelledby={`heading-${flushID}`}
      >
        <div className="accordion-body" style={{ fontSize: "18px" }}>{contentItem}</div>
      </div>
    </div>
  );
};

const padronProveedoresItems = [

  {
    year: "2025",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2025.pdf",
  },
  {
    year: "2026",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2026.pdf",
  },
];

const InformacionContable = () => {
  const [data, setData] = useState([]);
  const [openItems, setOpenItems] = useState({});

  useEffect(() => {
    document.title = "Información Contable y Financiera";
  }, []);

  useEffect(() => {
    console.log(
      "Datos cargados:",
      dataCuentaPublicaNew.find((item) => item.id === 36)?.items
    );
    setData(dataCuentaPublicaNew);
  }, []);
  const toggleItem = (id) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const columns = useMemo(() => {
    return [
      {
        accessorKey: "id",
        header: "ID",
        footer: "ID",
        enableResizing: false,
        size: 80,
      },
      {
        accessorKey: "year",
        header: "AÑO",
        footer: "AÑO",
        enableResizing: false,
        Filter: FilterYear,
        size: 80,
      },
      {
        accessorFn: (row) => `${row.title} ${row.year}`,
        id: "title",
        header: "NOMBRE",
        footer: "NOMBRE",
        size: 200,
      },
      {
        accessorKey: "link",
        header: "",
        footer: "",
        Cell: ({ cell, row }) =>
          row.original.isAccordion ? null : (
            <PdfLink url={cell.getValue() + ".pdf"} />
          ),
        size: 100,
      },
    ];
  }, []);

  const renderAccordionContent = (row) => {
    return (
      <div className="p-3">
        <table className="table table-hover">
          <tbody>
            {row.original.items.map((item) => (
              <tr key={item.id}>
                <td style={{ width: "50px", textAlign: "center" }}>
                  <PdfLink url={`${row.original.link}${item.link}.pdf`} />
                </td>
                <td style={{ paddingLeft: "20px" }}>
                  {item.title}{" "}
                  {/* Esto mostrará EXACTAMENTE lo que pusiste en el data */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Información Contable y Financiera" },
        ]}
      />

      <TitlePages title="Cuenta Pública" subTitle="" />
      <SinExpandir />
      <br />
      <br />

      <div
        style={{ overflowX: "auto", maxWidth: "100%", marginBottom: "60px" }}
      >
        <MaterialReactTable
          columns={columns}
          data={data}
          enablePagination={true}
          initialState={{ pagination: { pageSize: 5 } }}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10, 25, 50, 100],
            showFirstButton: true,
            showLastButton: true,
          }}
          localization={MRT_Localization_ES}
          renderDetailPanel={({ row }) =>
            row.original.isAccordion ? renderAccordionContent(row) : null
          }
        />
      </div>

      <TitlePages title="" subTitle="Información Financiera" />
      <div className="w-75 mx-auto">
        <ol className="list-group mb-0" style={{ fontSize: "18px" }}>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            <div className="ms-2 me-auto">
              <div>Remuneración Mensual</div>
            </div>
            <div>
              <a
                href="https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1.pdf"
                target="_blank"
                rel="noreferrer"
                className="me-2"
              >
                <span className="badge bg-danger" style={{ fontSize: "1.1rem" }}>
                  <FontAwesomeIcon icon={faFilePdf} />
                </span>
              </a>
            </div>
          </li>

          <li
            className="list-group-item d-flex justify-content-between align-items-center"
            onClick={() => toggleItem("padronProveedores")}
            style={{ cursor: "pointer", userSelect: "none" }}
            role="button"
            aria-expanded={!!openItems["padronProveedores"]}
          >
            <div className="ms-2 me-auto">
              <div
                style={{
                  fontWeight: 700,
                  fontFamily: "inherit",
                  color: "inherit",
                  letterSpacing: "normal",
                  WebkitTextStroke: "0px",
                }}
              >
                Padrón de Proveedores
              </div>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
                style={{
                  transform: openItems["padronProveedores"] ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                  color: "#6c757d",
                }}
                aria-hidden="true"
              >
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </li>

          {openItems["padronProveedores"] && (
            <li className="list-group-item p-0 border-top-0">
              <ul className="list-group list-group-flush bg-light">
                {padronProveedoresItems.map((item) => (
                  <li
                    key={item.year}
                    className="list-group-item bg-transparent d-flex align-items-center py-2 px-4 border-0"
                  >
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline-flex align-items-center text-decoration-none text-dark"
                      style={{ gap: "12px", fontSize: "18px" }}
                    >
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        style={{ color: "#d32f2f", fontSize: "1.4rem" }}
                      />
                      <span>{item.year}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          )}
        </ol>
      </div>
      <br />

      <div
        style={{ overflowX: "auto", maxWidth: "100%", marginBottom: "100px" }}
      >
        <Accordion
          idAccordion="informacionFinanciera"
          clasName={"w-75 mx-auto"}
        >
          {dataInfo2026.map((infoAccordion) => (
            <AccordionItem
              key={infoAccordion.id}
              flushID={infoAccordion.flushID}
              titleItem={infoAccordion.titleItem}
              contentItem={
                <ListBadge
                  ifNumbered={""}
                  listsBadgeItem={infoAccordion.children}
                />
              }
              isOpen={openItems[infoAccordion.id]}
              toggleItem={() => toggleItem(infoAccordion.id)}
            />
          ))}
        </Accordion>
      </div>
    </>
  );
};

export default InformacionContable;
